module.exports = __webpack_public_path__ + "img/admissionNotice.e23793c8.png";